//import axios from "axios";
import BackendLoginService from "../components/login-components/backendLoginService";

const api = BackendLoginService.getInstance();

// const api = axios.create({
//   baseURL: "/api/promo",
// });

export const insertPromo = (payload) => api.authPost(`/promo`, payload);
export const getAllPromos = () => api.authGet(`/promo`);
export const updatePromo = (payload) => api.authPut(`/promo`, payload);
export const deletePromoByCode = (code) => api.authDelete(`/promo/${code}`);
export const getPromoByCode = (code) => api.authGet(`/promo/${code}`);

const apis = {
  insertPromo,
  getAllPromos,
  updatePromo,
  deletePromoByCode,
  getPromoByCode,
};

export default apis;
